// extracted by mini-css-extract-plugin
export default {"textInputDiv":"textInputNormal_textInputDiv__7LIu1"};